import React from 'react'

function BuyMiner() {
  return (
    <div>BuyMiner</div>
  )
}

export default BuyMiner